module.exports = __webpack_public_path__ + "img/14.527e7aad.png";